import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';

export default function myProgressCollaborationStatsReducer(state = initialState.myProgressCollaborationStats, action) {
	switch (action.type) {
		case types.MY_PROGRESS_COLLABORATION_GET_REQUEST_STATS:
			return {
				...action.response
			};
		default:
			return state;
	}
}
